import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar/Sidebar';
import { SlimTopBar } from './SlimTopBar/SlimTopBar';
import { useNavigation } from '../../contexts/NavigationContext';
import { useTheme } from '../../contexts/ThemeContext';
import { LAYOUT_DIMENSIONS } from '../../types/navigation';
import { transitions } from '../../theme/tokens';
import './AppLayout.css';

export function AppLayout() {
  const { isCollapsed } = useNavigation();
  const { theme } = useTheme();

  const sidebarWidth = isCollapsed
    ? LAYOUT_DIMENSIONS.SIDEBAR_WIDTH_COLLAPSED
    : LAYOUT_DIMENSIONS.SIDEBAR_WIDTH_EXPANDED;

  return (
    <Box className="app-layout" data-theme={theme}>
      <SlimTopBar />
      <Box className="app-layout__body">
        <Sidebar />
        <Box
          component="main"
          className="app-layout__content"
          sx={{
            marginLeft: `${sidebarWidth}px`,
            transition: `margin-left ${transitions.duration.normal}ms ${transitions.easing.easeInOut}`,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
